import { render } from "./PartnerWalletView.vue?vue&type=template&id=3997a025"
import script from "./PartnerWalletView.vue?vue&type=script&lang=js"
export * from "./PartnerWalletView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__